import React from "react";
import { Navigate, useParams } from "react-router-dom";
import SacredChatPage from "./SacredChatPage";
import { ELEMENTS, ELEMENT_SUGGESTIONS } from "@/lib/elements";

export default function ElementChat() {
  const { id } = useParams();
  const el = ELEMENTS.find((e) => e.id === id);
  if (!el) return <Navigate to="/elements" replace />;
  return (
    <SacredChatPage
      key={el.id}
      persona={el.persona}
      personaLabel={el.fr.name}
      IconComponent={el.Icon}
      accent={el.accent}
      unlimited
      kickerLabel={{ fr: "conscience élémentaire · gratuit illimité", en: "elemental consciousness · free unlimited" }}
      backTo="/elements"
      theme={{
        bgRadial: `radial-gradient(ellipse at top, ${el.accent}30 0%, ${el.bg} 50%, #020207 100%)`,
        fg: "#eef2ff",
        msgBg: "linear-gradient(180deg, rgba(8,10,22,0.9), rgba(2,3,8,0.95))",
        msgFg: "rgba(238,242,255,0.8)",
      }}
      title={{
        fr: <>La conscience <span className="italic" style={{ color: el.accent }}>{el.fr.of}</span>.</>,
        en: <>The consciousness of <span className="italic" style={{ color: el.accent }}>{el.en.name}</span>.</>,
      }}
      subtitle={{
        fr: `${el.fr.line} Pose n'importe quelle question : ${el.fr.name.toLowerCase()} te répond depuis sa vision primordiale et te ramène à sa conscience.`,
        en: `${el.en.line} Ask any question: ${el.en.name} answers from its primordial vision and brings you back to its consciousness.`,
      }}
      greeting={{ fr: el.fr.greet, en: el.en.greet }}
      suggestions={ELEMENT_SUGGESTIONS}
      inputPlaceholder={{ fr: "Pose n'importe quelle question…", en: "Ask any question…" }}
      playlist={el.playlist}
    />
  );
}
